import analytics from 'yoda-core-components/lib/helpers/Analytics/Analytics';
import get from 'lodash/get';

import { MY_APPOINTMENTS_PAGE_LOADED_SUCCESS } from 'yoda-site-components/lib/actionTypes/AppointmentActionTypes';
import { SIGNIN_PAGE_LOADED_SUCCESS } from 'yoda-site-components/lib/actionTypes/SigninActionTypes';
import {
    CREATE_ACCOUNT_PAGE_LOADED_SUCCESS,
    SIGNOUT_PAGE_LOAD_ACTION,
} from 'yoda-site-components/lib/actionTypes/CreateAccountActionTypes';
import { logwebvitals } from 'yoda-site-components/lib/middlewares/WebvitalsMiddleware';

import * as CAMDashboardActionTypes from '../actionTypes/CAMDashboardActionTypes';
import * as WalletBarcodeActionTypes from '../actionTypes/WalletBarcodeActionTypes';
import { PROMOTIONAL_ANALYTICS_ACTION } from '../actionTypes/CAMDashboardActionTypes';
// eslint-disable-next-line import/no-named-as-default
import CAMActionFilter from '../analytics/CAMDashboardActionFilter';
import AppointmentActionFilter from '../analytics/AppointmentActionFilter';
import * as CJAAnalyticsService from '../services/CJAAnalyticsService';

const camActionFilter = new CAMActionFilter();
const appointmentActionFilter = new AppointmentActionFilter();
/**
 * This function will used only for redux middleware only to track tagging based on action request
 */
const AccountAnalyticsMiddleware = store => next => action => { // eslint-disable-line
    if (!__SERVER__) {
        let digitalData = null;
        let analyticsEventName = null;
        let cjaPageName = null;
        const { context } = store.getState();
        const enableCJAAnalytics = context?.featureFlags?.enableCJAAnalytics;
        /**
         * component can trigger an action only for tagging
         * action should contain analytics object as mandatory
         * @param analytics.type - {string}  - tagging key
         * @param analytics.JCPDL - {Object}  - required additional details for tagging event
         */
        try {
            switch (action.type) {
                case MY_APPOINTMENTS_PAGE_LOADED_SUCCESS:
                    cjaPageName = 'my appointments';
                    digitalData = appointmentActionFilter.getAppointmentPageDL(store);
                    analyticsEventName = 'digitalDataReady';
                    logwebvitals(store, digitalData);
                    break; /* istanbul ignore next */
                case CAMDashboardActionTypes.CAM_PAGE_ANALYTICS_ACTION:
                    if (action?.payload?.trackEvent === 'digitalDataReady') {
                        cjaPageName = action?.payload?.pageName;
                    }
                    digitalData = camActionFilter.getCAMDashboardPageDL(store, action.payload);
                    digitalData = camActionFilter.updateCommonDigitalData(digitalData);
                    analyticsEventName = action.payload.trackEvent;
                    logwebvitals(store, digitalData);
                    break; /* istanbul ignore next */
                case PROMOTIONAL_ANALYTICS_ACTION:
                    digitalData = camActionFilter.getPromotionalEmailPreferences(
                        action.payload.preferences
                    );
                    analyticsEventName = action.payload.trackEvent;
                    break; /* istanbul ignore next */
                case WalletBarcodeActionTypes.WALLET_CAPTCHA_ANALYTICS:
                    digitalData = action.data;
                    analyticsEventName = action.eventName;
                    break;
                case SIGNIN_PAGE_LOADED_SUCCESS:
                    cjaPageName = 'sign in';
                    break;
                case CREATE_ACCOUNT_PAGE_LOADED_SUCCESS:
                    cjaPageName = action?.payload?.pageName || 'create account';
                    break;
                case SIGNOUT_PAGE_LOAD_ACTION:
                    cjaPageName = action?.payload?.pageName || 'session timeout';
                    break;
                default:
                    break;
            }
            if (enableCJAAnalytics && cjaPageName) {
                CJAAnalyticsService.trackCJAPageView(store, cjaPageName);
            }
            if (analyticsEventName || digitalData) {
                analyticsEventName === 'digitalDataReady' &&
                    // eslint-disable-next-line no-console
                    console.info('digitalData -', digitalData);
                digitalData.dataVersion = 1;
                const track = () => {
                    analytics.track(analyticsEventName, digitalData);
                };
                /* istanbul ignore if */
                if (get(digitalData, 'page.pageInfo.name', '') === 'ALMOST DONE - modal') {
                    setTimeout(track, 4000);
                } else {
                    track();
                }
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }
    }
    if (action.type) {
        return next(action);
    }
};

export default AccountAnalyticsMiddleware;
